import React, { useState } from "react";
import styles from "./addTags.module.css";
import { Button, Modal } from "react-bootstrap";
import { CiCirclePlus } from "react-icons/ci";
import TMSDataTablePagination from "../../../../components/TMSTable";
// import { useNavigate } from "react-router-dom";
import { BsThreeDotsVertical } from "react-icons/bs";
import Swal from "sweetalert2";
import { post } from "../../../../components/api";
import { ReactSelect } from "../../../../components/ReactSelect";

const AddTags = () => {
  const [searchFirm, setSearchFirm] = useState("");
  const [show, setShow] = useState(false);
  const [newTag, setNewTag] = useState("");
  const [selectedTag, setSelectedTag] = useState({
    _id: "urgent",
    name: "Urgent",
  });
  // const navigate = useNavigate();
  const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <a
      href=""
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
    >
      {children}
      <BsThreeDotsVertical size={"20px"} color="#2A7C7A" />
    </a>
  ));
  CustomToggle.displayName = "CustomToggle";

  const handleClick = async () => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this vendor!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        const response = await post("https://your-api-url.com/delete", {});

        if (response.status === 200) {
          Swal.fire(
            "Deleted!",
            "Your vendor has been deleted successfully.",
            "success"
          );
        } else {
          Swal.fire(
            "Error!",
            "Something went wrong. Please try again.",
            "error"
          );
        }
      } catch (error) {
        Swal.fire("Error!", "Failed to connect to the server.", "error");
      }
    }
  };
  const columns = [
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
      grow: 1,
    },
    {
      name: "Tag Type",
      selector: (row) => row.type,
      sortable: true,
      grow: 1,
    },
    {
      name: "Actions",
      width: "250px",
      cell: (row) => (
        <div className={styles.buttons}>
          <button type="button" className={styles.UpdateButton}>
            Update
          </button>
          <button
            type="button"
            onClick={() => handleClick(row)}
            className={styles.DeleteButton}
          >
            Delete
          </button>
        </div>
      ),
      button: true,
    },
  ];

  // const data = [
  //   {
  //     name: "ABC Pvt. Ltd.",
  //     type: "www.abc.com",
  //   },
  //   {
  //     name: "ABC Pvt. Ltd.",
  //     type: "www.abc.com",
  //   },
  //   {
  //     name: "ABC Pvt. Ltd.",
  //     type: "www.abc.com",
  //   },
  //   {
  //     name: "ABC Pvt. Ltd.",
  //     type: "www.abc.com",
  //   },
  // ];
  const handleCancel = () => {
    setShow(!show);
  };

  const handleSubmit = async () => {
    const data = await post("admin/tms/add/tag", { newTag, selectedTag });
    if (data.status == 200) {
      setShow(false);
      setNewTag("");
    }
  };

  return (
    <div className={styles.MainDiv}>
      <div className={styles.HeadDiv}>
        <p className={styles.Heading}>Tags</p>
        <div className={styles.HeaderSearchbar}>
          <input
            className={styles.Input}
            // className="form-control"
            id="name"
            name="name"
            placeholder="Search Tag"
            onChange={(e) => setSearchFirm(e.target.value)}
            value={searchFirm}
          />
          <Button
            className={styles.addButton}
            variant="outline-secondary"
            onClick={handleCancel}
          >
            <CiCirclePlus size={16} /> Add
          </Button>
        </div>
      </div>
      <div className={styles.ContentDiv}>
        <div className={styles.data_table_wrapper}>
          <TMSDataTablePagination
            columns={columns}
            apiUrl={"admin/tms/tags-list"}
            queryObj={""}
            // data1={data}
          />
        </div>
      </div>
      <Modal
        show={show}
        centered
        backdrop="static"
        onHide={() => handleCancel()}
      >
        <Modal.Header closeButton>
          <Modal.Title className="reportModalTitle">
            Add tag to address: This New Address
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <label className="route-label mb-2">Tag</label>
            <input
              className="form-control input-field mb-2"
              id="Name"
              name="Name"
              placeholder="Enter Name"
              onChange={(e) => setNewTag(e.target.value)}
              value={newTag}
            />
            <label className="route-label mb-2">Please select Tag type</label>
            <ReactSelect
              name="Tag"
              value={selectedTag} // Ensure it's an object like { _id: "...", name: "..." }
              options={[
                { _id: "urgent", name: "Urgent" },
                { _id: "normal", name: "Normal" },
              ]}
              handleOnChange={(name, value) => {
                setSelectedTag(value);
              }}
              isSearchable={true}
              isLoading={false}
              noOptionsMessage={() => "Tag not available."}
              placeholder="Select Tag"
            />
          </div>
          <div className={styles.buttons1}>
            <button className={styles.CancelButton}>Cancel</button>
            <button
              type="submit"
              className={styles.SubmitButton}
              onClick={handleSubmit}
            >
              Create
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default AddTags;
